<table class="table table-striped webtext-black">
      <thead>
        <tr>
          <th scope="col">Saved Search Name</th>
          <th scope="col">Created Date</th>
          <th scope="col">Updated Date</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let savedSearch of savedSearches">
          <td>{{savedSearch['savedSearchName']}}</td>
          <td>{{this.apiService.formatDate(savedSearch['createdTS'])}}</td>
          <td>{{this.apiService.formatDate(savedSearch['updatedTS'])}}</td>
          <td>
            <a *ngIf="(this.impersonatedEmail != null && this.consultantRoleName == 'READ_ONLY_ACCESS')"
               (click)="onViewSavedSearch(savedSearch)">
              <i class="bi bi-eye"></i>
            </a>
            &nbsp;
            <a *ngIf="(this.username && this.impersonatedEmail == null) || (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
               (click)="onDeleteSavedSearch(savedSearch)">
              <i class="bi bi-trash"></i>
            </a>
            &nbsp;
            <a *ngIf="(this.username && this.impersonatedEmail == null) || (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
              (click)="onEditSavedSearch(savedSearch)">
              <i class="bi bi-pencil-fill"></i>
            </a>
            &nbsp;
            <a (click)="onApplySavedSearch(savedSearch)">
              <i class="bi bi-search"></i>
            </a>
          </td>
        </tr>
      </tbody>
</table>

